/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminOrganizationsResponse,
  GetOrganizationsParams,
  GetReviewDataParams,
  HTTPValidationError,
  ReviewOrgData,
  SendProvideWebsiteEmailParams,
  SrcRoutersAdminOrganizationsUpdateVettingRequest,
} from './platformapi.schemas';

import getOrganizationsMutator from '../custom-axios-instance';
import getReviewDataMutator from '../custom-axios-instance';
import sendProvideWebsiteEmailMutator from '../custom-axios-instance';
import updateOrgVettingMutator from '../custom-axios-instance';

/**
 * Get all organizations
 * @summary Get Organizations
 */
export const getOrganizations = (params: GetOrganizationsParams, signal?: AbortSignal) => {
  return getOrganizationsMutator<AdminOrganizationsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetOrganizationsQueryKey = (params: GetOrganizationsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/organizations/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizations>>> = ({ signal }) =>
    getOrganizations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>;
export type GetOrganizationsQueryError = void | HTTPValidationError;

export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organizations
 */

export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = void | HTTPValidationError,
>(
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOrganizationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get organization vetting data
 * @summary Get Review Data
 */
export const getReviewData = (params: GetReviewDataParams, signal?: AbortSignal) => {
  return getReviewDataMutator<ReviewOrgData>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/organization_vetting`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetReviewDataQueryKey = (params: GetReviewDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/organizations/organization_vetting`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReviewDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  params: GetReviewDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReviewDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewData>>> = ({ signal }) =>
    getReviewData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReviewDataQueryResult = NonNullable<Awaited<ReturnType<typeof getReviewData>>>;
export type GetReviewDataQueryError = void | HTTPValidationError;

export function useGetReviewData<
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  params: GetReviewDataParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewData>>,
          TError,
          Awaited<ReturnType<typeof getReviewData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReviewData<
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  params: GetReviewDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewData>>,
          TError,
          Awaited<ReturnType<typeof getReviewData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReviewData<
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  params: GetReviewDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Review Data
 */

export function useGetReviewData<
  TData = Awaited<ReturnType<typeof getReviewData>>,
  TError = void | HTTPValidationError,
>(
  params: GetReviewDataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewData>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetReviewDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Send email to organization to provide their website
 * @summary Send Provide Website Email
 */
export const sendProvideWebsiteEmail = (
  params: SendProvideWebsiteEmailParams,
  signal?: AbortSignal,
) => {
  return sendProvideWebsiteEmailMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/provide_website_email`,
    method: 'POST',
    params,
    signal,
  });
};

export const getSendProvideWebsiteEmailMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendProvideWebsiteEmail>>,
    TError,
    { params: SendProvideWebsiteEmailParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendProvideWebsiteEmail>>,
  TError,
  { params: SendProvideWebsiteEmailParams },
  TContext
> => {
  const mutationKey = ['sendProvideWebsiteEmail'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendProvideWebsiteEmail>>,
    { params: SendProvideWebsiteEmailParams }
  > = (props) => {
    const { params } = props ?? {};

    return sendProvideWebsiteEmail(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendProvideWebsiteEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendProvideWebsiteEmail>>
>;

export type SendProvideWebsiteEmailMutationError = void | HTTPValidationError;

/**
 * @summary Send Provide Website Email
 */
export const useSendProvideWebsiteEmail = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendProvideWebsiteEmail>>,
      TError,
      { params: SendProvideWebsiteEmailParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendProvideWebsiteEmail>>,
  TError,
  { params: SendProvideWebsiteEmailParams },
  TContext
> => {
  const mutationOptions = getSendProvideWebsiteEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update organization vetting status
 * @summary Update Org Vetting
 */
export const updateOrgVetting = (
  srcRoutersAdminOrganizationsUpdateVettingRequest: SrcRoutersAdminOrganizationsUpdateVettingRequest,
  signal?: AbortSignal,
) => {
  return updateOrgVettingMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/organizations/update_vetting`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: srcRoutersAdminOrganizationsUpdateVettingRequest,
    signal,
  });
};

export const getUpdateOrgVettingMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrgVetting>>,
    TError,
    { data: SrcRoutersAdminOrganizationsUpdateVettingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrgVetting>>,
  TError,
  { data: SrcRoutersAdminOrganizationsUpdateVettingRequest },
  TContext
> => {
  const mutationKey = ['updateOrgVetting'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrgVetting>>,
    { data: SrcRoutersAdminOrganizationsUpdateVettingRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateOrgVetting(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrgVettingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrgVetting>>
>;
export type UpdateOrgVettingMutationBody = SrcRoutersAdminOrganizationsUpdateVettingRequest;
export type UpdateOrgVettingMutationError = void | HTTPValidationError;

/**
 * @summary Update Org Vetting
 */
export const useUpdateOrgVetting = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrgVetting>>,
      TError,
      { data: SrcRoutersAdminOrganizationsUpdateVettingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrgVetting>>,
  TError,
  { data: SrcRoutersAdminOrganizationsUpdateVettingRequest },
  TContext
> => {
  const mutationOptions = getUpdateOrgVettingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
